import { SAVE_TABLE_STATE, SAVE_LAST_SEARCH_TAB } from "../actions/types";

const initialState = {
  tableState: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_TABLE_STATE:
      return {
        ...state,
        tableState: { ...state.tableState, ...action.payload },
      };
    case SAVE_LAST_SEARCH_TAB: {
      return {
        ...state,
        lastSearchTab: action.payload,
      };
    }
    default:
      return state;
  }
}
